(function(){
    var sec = document.currentScript.previousElementSibling;
    while (sec && !(sec.classList && sec.classList.contains('tp-suk'))) { sec = sec.previousElementSibling; }
    if (!sec) return;
    var chats = sec.querySelectorAll('[data-open-talki]');
    function openWidget(e){
      e.preventDefault();
      var sel = '#talki-launcher,.talki-launcher,[data-talki-launcher],#chat-widget-launcher,.chat-launcher';
      var el = null;
      try { el = document.querySelector(sel); } catch(err){}
      if (el) { el.click(); }
      else if (typeof window.openTalki === 'function') { window.openTalki(); }
      else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    }
    for (var i=0;i<chats.length;i++){ chats[i].addEventListener('click', openWidget); }
  })();
